<template>
	<inertia-head title="Home" />
	<ContentSlot ref="contentSlot" :errors="errors" :flash="flash"/>

	<div class="content">

	</div>

</template>

<script>
import { debounce } from 'lodash';	
import { watch, onMounted, ref } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import ContentSlot from './ContentSlot';
import { createToaster } from '@meforma/vue-toaster'
import { useForm, usePage } from '@inertiajs/inertia-vue3'


export default {
	props:{
		user 		: Object,
		errors 		: Object,
		flash 		: Object,
		posts 		: Object,
	},
	layout: AuthLayout,
	setup(props) {

		return{

		}
	}
}	
</script>